import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';

export default class UrbanAirshipRoute extends Route {
  @service environment;

  crumb() {
    return {
      name: 'Urban Airship',
      path: 'actions.urban_airship',
    };
  }

  redirect() {
    if (!this.environment.current.enabledActions.includes('urban_airship')) {
      this.router.replaceWith('workspace-settings');
    }
  }

  setupController(controller) {
    controller.get('loadCredential').perform();
  }
}
